<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Masters <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Stream Master <i
                    class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Edit Stream</h1>
            <div class="content-wrap">
                <form [formGroup]="editStreamForm">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="streamName" class="form-label">Stream Name<span
                                        class="color-red">*</span></label>
                                <input type="text" placeholder="Enter the Stream name" formControlName="streamName"
                                    [(ngModel)]="streamName" class="form-control form-input" id="streamName"
                                    [ngClass]="{'is-invalid': submitted && f.streamName.errors }" />
                                <div *ngIf="submitted && f.streamName.errors" class="invalid-feedback">
                                    <div *ngIf="f.streamName.errors.required">Stream Name is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="proceed-btn bg-theme" (click)="updateStream()">Submit</button>
                    <button class="proceed-btn" (click)="goBack()">Cancel</button>     
                </form>
            </div>
        </div>
    </div>
</div>

<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap"><img src="assets/images/thumb-up.png" class="fa-icon-modal"
                        alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>